module.exports = __webpack_public_path__ + "static/media/opportunity-mgmt.146e1300.svg";